import { Pipe, PipeTransform } from '@angular/core';
import { formatParisDay } from '../utils/paris-day.util';

/**
 * Affiche le jour de Paris d'une date de l'API (date seule ou horodatage).
 * Usage : `{{ lilate.earliest_start_date | parisDay }}` ou `{{ date | parisDay:'DD/MM' }}`.
 */
@Pipe({
    name: 'parisDay',
    standalone: true,
})
export class ParisDayPipe implements PipeTransform {
    transform(value: Date | string | null | undefined, format = 'DD/MM/YYYY'): string {
        return formatParisDay(value, format);
    }
}
